import { render, staticRenderFns } from "./DetentionHistoriesCard.vue?vue&type=template&id=4fae97aa&"
import script from "./DetentionHistoriesCard.vue?vue&type=script&lang=js&"
export * from "./DetentionHistoriesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports